import React, { useEffect, useState } from "react";
import DotedPart from "../common/DotedPart";
import HeroSection from "../thirdScreen/HeroSection";
import BenefitsofBugBounty from "../thirdScreen/BenefitsofBugBounty";
import LeftRightComo1 from "../images/omniplatform.png";
import LeftRightComo2 from "../images/omniaichat.png";
import LeftRightComo4 from "../images/finacial.png";
import riskDataImg from "../images/risk_data.png";
import esgData from "../images/esg_data.png";
import HomeDiscoverPart from "../firstScreen/HomeDiscoverPart";
import DataWarehousing from "../thirdScreen/DataWarehousing";
import { useTranslation } from "react-i18next";

const IndexSolutions = ({ sectionRef }) => {
  const { t } = useTranslation();
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth >= 640
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth >= 640);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const data = [
    {
      mainTitle: t("omni_platform"),
      subTitle: t("omni_platform_desc"),
      image: LeftRightComo1,
      buttonText: t("get_started"),
      section: "OmniPlatform",
    },
    {
      mainTitle: t("omni_ai_platform"),
      subTitle: t("omni_ai_platform_desc"),
      image: LeftRightComo2,
      buttonText: t("get_started"),
      section: "OmniAiChatbot",
    },
  ];

  const data1 = [
    {
      mainTitle: t("financial_data"),
      subTitle: t("financial_data_desc"),
      list: [
        t("financial_data_list1"),
        t("financial_data_list2"),
        t("financial_data_list3"),
      ],
      image: LeftRightComo4,
      buttonText: t("get_started"),
      section: "FinancialData",
    },
    {
      mainTitle: t("risk_data"),
      subTitle: t("risk_data_desc"),
      list: [
        t("risk_data_list1"),
        t("risk_data_list2"),
        t("risk_data_list3"),
        t("risk_data_list4"),
      ],
      image: riskDataImg,
      buttonText: t("get_started"),
      section: "RiskData",
    },
    {
      mainTitle: t("esg_data"),
      subTitle: t("esg_data_desc"),
      list: [
        t("esg_data_list1"),
        t("esg_data_list2"),
        t("esg_data_list3"),
        t("esg_data_list4"),
      ],
      image: esgData,
      buttonText: t("get_started"),
      section: "ESGData",
    },
  ];
  return (
    <>
      <HeroSection isMobileScreen={isMobileScreen} />
      {/* <div

                className=" relative z-[1] sm:z-[-1] bottom-[77px] sm:bottom-[100px]"
            >
                <img draggable="false"
                    src={videoPlayImage}
                    style={{
                        position: "relative",
                        // top: "0px",
                        zIndex: 2,
                        // filter: "brightness(0.5)",
                        width: "100%",
                        height: "fit-content",
                        objectFit: "contain",
                        marginTop: '-77px'
                    }}
                    alt="videoPlay"
                // className="bottom-[650px]  sm:bottom-[570px] xl:bottom-[400px] h-[100vh] xl:h-[auto]"
                />
                // <img draggable="false"
                 //   alt="text"
                  //  src={imgText}
                   // className="absolute top-[13%] sm:top-[33%] right-[7%] sm:right-[20%] z-[2]"
                // style={{ position: "absolute", top: "-16%", right: "20%" }}
                // /> 
            </div> */}
      {/* <Marque title={"Trusted By Web3’s Most Innovative Teams"} /> */}
      {/* <WhatIsBugBounty /> */}
      {/* <div className="mt-3"> */}
      <DotedPart className="mt-[50px] md:mt-[10px] mb-[50px] md:mb-[89px]" />
      {/* </div> */}
      {/* <div className="mt-0 sm:mt-20">
                <HomeTakeExport content="We are here to assist you and answer any questions you may have. Our team can assist you in defining and implementing the digitalization of compliance reporting." />
            </div> */}
      <BenefitsofBugBounty
        title={"Platform"}
        data={data}
        sectionRef={sectionRef}
      />
      {/* <div className="mt-7"> */}
      <DotedPart className="mt-[50px] md:mt-[30px] mb-[50px] md:mb-[89px]" />
      {/* </div> */}
      <HomeDiscoverPart />
      {/* <div className="mt-7"> */}
      <DotedPart className="mt-[70px] md:mt-[89px] mb-[50px] md:mb-[89px]" />
      {/* </div> */}
      <DataWarehousing title={"Data Warehousing"} data={data1} />
      {/* <FasterWithIntegrations /> */}
      <DotedPart className="mt-[30px] md:mt-[20px] mb-[50px] md:mb-[89px]" />
    </>
  );
};

export default IndexSolutions;
